uniform sampler2D donaldTexture;
uniform sampler2D donaldoTexture;

uniform sampler2D flagTexture;
uniform sampler2D uImage;

uniform float time;
uniform float hoverState;
varying float vNoise;
varying vec2 vUv;

void main() {
  vec3 color = vec3(0., 0., 0.);
  vec3 color1 = vec3(0., 0., 1.);
  vec2 newUV = vUv;

  // CODROPS START
  vec2 p = newUV;
  float x = hoverState;
  x = smoothstep(.0, 1.0, (x * 2.0 + p.y - 1.0));
  vec4 f = mix(texture2D(uImage, (p - .5) * (1. - x) + .5),
               texture2D(uImage, (p - .5) * x + .5), x);
  // gl_FragColor = f;
  // CODROPS ENDS

  // vec3 finalColor = mix(color, color1, .5 * (vNoise + 1.));

  // gl_FragColor = vec4(finalColor, .6);
  // gl_FragColor = vec4(vUv, 0., 1.);

  //   vec4 donald = texture2D(donaldTexture, vUv);
  //   vec4 donaldo = texture2D(donaldoTexture, vUv);
  vec4 flag = texture2D(uImage, newUV);
  // gl_FragColor = flag + .5 * vec4(vNoise);
  // gl_FragColor = vec4(vNoise, 0., 0., 1.);
  gl_FragColor = f;
  gl_FragColor.rgb += .005 * vec3(vNoise);
}